<template>
  <div
    class="wt2-search2014-component"
    :class="{ '-focus': isFocus, '-hover': isHover }"
    @mouseenter="toggleHover(true)"
    @mouseleave="toggleHover(false)"
  >
    <div class="-stage">
      <input
        class="wt2-text-l"
        type="text"
        maxlength="1024"
        :id="guid"
        :value="query"
        :disabled="disabled"
        ref="input"
        @input="onInput"
        @keyup.enter="onEnter"
        @focus="toggleFocus(true)"
        @blur="toggleFocus(false)"
      />
      <div class="-favicon" @click="onEnter">
        <i class="wticon wticon-magnifier" />
      </div>
    </div>
    <div class="-curtains">
      <div
        class="-placeholder"
        v-show="showPlaceholder"
        v-text="placeholderText"
      />
      <div class="-reset" v-show="showReset" @mousedown="onReset">
        <i class="wticon wticon-close" />
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    // 2026 HORIZONTAL ELLIPSIS
    placeholderText: { type: String, default: 'Search\u2026' },
  },

  watch: {
    value() {
      this.query = this.value;
    },
    disabled() {
      this.$refs.input.disabled = this.disabled;
    },
  },

  data() {
    return {
      query: '',
      guid: app.guid(),
      isFocus: false,
      isHover: false,
    };
  },

  created() {
    this.query = this.value.normalizeSpace();
  },

  computed: {
    showPlaceholder() {
      return _.isEmpty(this.query);
    },

    showReset() {
      return !_.isEmpty(this.query);
    },
  },

  methods: {
    onInput(e) {
      this.query = e.target.value;
      this.$emit('input', this.query);
    },

    onEnter() {
      this.$emit('input', this.query);
      this.$emit('trigger', this.query);
    },

    toggleFocus(v) {
      this.isFocus = v;
    },

    toggleHover(v) {
      this.isHover = v;
    },

    onReset() {
      this.query = '';
      const $el = this.$el.querySelector('input');
      $el.value = this.query;
      this.$emit('input', this.query);
      this.$emit('trigger', this.query);

      setTimeout(() => {
        if (!this._isDestroyed) {
          $el.focus();
        }
      }, 10);
    },
  },
};
</script>
